import React from 'react';

const AnimatedGrid = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Animated grid */}
      <div className="absolute inset-0 tech-grid opacity-30"></div>
      
      {/* Scan line */}
      <div className="scan-line"></div>
      
      {/* Data streams */}
      {[...Array(15)].map((_, i) => (
        <div
          key={i}
          className="data-stream"
          style={{
            left: `${(i / 15) * 100}%`,
            animationDelay: `${i * 0.3}s`,
            animationDuration: `${3 + Math.random() * 2}s`
          }}
        />
      ))}
      
      {/* Floating geometric shapes */}
      <div className="absolute top-1/4 left-1/4 w-32 h-32 border border-cyan-500/20 rotate-45 morphing-shape"></div>
      <div className="absolute top-1/3 right-1/4 w-24 h-24 border border-blue-500/20 rounded-full" style={{animation: 'float 8s ease-in-out infinite'}}></div>
      <div className="absolute bottom-1/4 left-1/3 w-28 h-28 border border-cyan-500/20 hexagon" style={{animation: 'float 10s ease-in-out infinite', animationDelay: '2s'}}></div>
    </div>
  );
};

export default AnimatedGrid;
